@use '@lib/assets/styles/main.scss' as *;

$imageSize: 48px;

.wrap {
  padding-left: $imageSize + 8px;
  position: relative;
}

.wrapDisabled {
  @extend %disabledGrayscale;
}

.icon {
  position: absolute;
  top: 0;
  left: 0;
  width: $imageSize;
  img, svg {
    display: block;
    max-width: 100%;
    height: auto;
  }
  img {
    object-fit: cover;
    width: $imageSize;
    height: $imageSize;
    border-radius: 4px;
    border: 1px solid $gray200;
  }
}

.info {
  min-height: 48px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  & > * {
    display: block;
    word-break: break-word;
    width: 100%;
    & + * {
      margin-top: -4px;
    }
  }
}

.name {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.code {
  color: $gray500;
  overflow: hidden;
  text-overflow: ellipsis;
}
